// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Example: EXPIRES_TODAY

export const BindingExpirationSchema = t.keyof({
  EXPIRES_TODAY: null,
  EXPIRES_LESS_THAN_30_DAYS: null,
  EXPIRES_MORE_THAN_30_DAYS: null,
});

export type BindingExpiration = t.TypeOf<typeof BindingExpirationSchema>;
